import { useEffect, useState } from "react";
import { _AdquisitionContract, _BudgetRPFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import { InputDate } from "../../theme/Input/InputDate";
import { AccountEditor } from "../../editor/AccountEditor";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import { BasicMultiSelectTable } from "../../theme/Component/BasicMultiSelecTable";
import { PrintJson } from "../../theme/Component/PrintJson";
import { EditorAdquisitionContractSelect } from "../../contract/etapa-contrato/contrac/EditorAdquisitionContractSelect";

interface Props {
    onChange: Function;
}

export const BudgetObligationForm = ({ onChange }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_BudgetRPFactory);
    const [listaResult, setListaResult] = useState<any>([]);
    const [typeSource, setTypeSource] = useState<"Contrato" | "Tercero">("Contrato");

    const [response, setResponse] = useState<any>({
        RegisterDate: _single.getCurrenDate(),
    });

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Valor del Registro Presupuestal', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Valor Obligado', property: 'OBValue', visible: true },
    ];

    useEffect(() => {
        const obje = {
            RegisterDate: response.RegisterDate,
            Beneficiary: response.IDAccount,
            Description: response.Description,
            Consecutive: response.Consecutive,
            RPList: listaResult,
        };
        onChange(obje);
    }, [response, bean, listaResult]);

    useEffect(() => {
        setLista([]);
        setListaResult([])
        setResponse({ ...response, IDAccount: null, Contract: null });
    }, [typeSource])

    useEffect(() => {
        if (response.IDAccount && response.RegisterDate && typeSource === "Tercero") {
            getRPConsecutive();
        } else if (response.Contract?.IDAdquisitionContract && typeSource === "Contrato") {
            getRPContract()
        }
    }, [response.IDAccount, response.Contract?.IDAdquisitionContract, response.RegisterDate]);

    const getRPConsecutive = () => {
        instance.getRPDocuments(response.IDAccount, response.RegisterDate).then(
            (resp) => setLista(resp)
        ).catch(err => toast.error(err));
    };

    const getRPContract = () => {
        instance.getBudgetRecordForAdquisitionContract(response.Contract?.IDAdquisitionContract, response.Contract?.AdquisitionContractDate, _single.getCurrenDate()).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }


    return (
        <div className="row">
            {/* <PrintJson json={response}/> */}
            <div className="col-md-12">
                <div className="row">

                    <div className="col-md-6">
                        <label>Tipo de origen de la Obligación</label>
                        <select className="form-select" value={typeSource} onChange={(e) => setTypeSource(e.target.value as "Contrato" | "Tercero")}>
                            <option value="Tercero">Tercero</option>
                            <option value="Contrato">Contrato</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div className="row">

                    <div className="col-md-3">
                        <InputDate name="" label="Fecha de Registro" setDate={(e) => { setResponse({ ...response, "RegisterDate": e }) }} value={response.RegisterDate} />
                    </div>


                    {typeSource === "Contrato" && (
                        <div className="col-md-5">
                            <EditorAdquisitionContractSelect  onChange={(e) => setResponse({ ...response, "Contract": e,"IDAccount":e.IDAccount })} />
                        </div>
                    )}

                    {typeSource === "Tercero" && (
                        <div className="col-md-5">
                            <AccountEditor idAccount={response.IDAccount} label="Beneficiario" onChange={(e) => setResponse({ ...response, "IDAccount": e.IDAccount })} />
                        </div>
                    )}

                    <div className="col-md-4">
                        <label>Numero de Consecutivo Externo</label>
                        <input type="number" value={response.Consecutive} onChange={(e) => { setResponse({ ...response, "Consecutive": parseInt(e.target.value) }) }} className="form-control" />
                    </div>

                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea className="form-control" value={response.Description} onChange={(e) => { setResponse({ ...response, "Description": e.target.value }) }}></textarea>
                    </div>

                    <div className="col-md-12 mt-2">
                        <BasicMultiSelectTable body={lista} head={head} bodyResult={listaResult} keyId="IDDocument" updateValues={({ bodyResult }) => {
                            setListaResult(bodyResult);
                        }} />
                    </div>
                </div>
            </div>

        </div>
    );
}